<template>
<!-- Created with Inkscape (http://www.inkscape.org/) -->

<svg
   version="1.1"
   id="svg2328"
   xml:space="preserve"
   width="682.66669"
   height="682.66669"
   viewBox="0 0 682.66669 682.66669"
   xmlns="http://www.w3.org/2000/svg"
   xmlns:svg="http://www.w3.org/2000/svg"><defs
     id="defs2332"><clipPath
       clipPathUnits="userSpaceOnUse"
       id="clipPath2342"><path
         d="M 0,512 H 512 V 0 H 0 Z"
         id="path2340" /></clipPath></defs><g
     id="g2334"
     transform="matrix(1.3333333,0,0,-1.3333333,0,682.66667)"><g
       id="g2336"><g
         id="g2338"
         clip-path="url(#clipPath2342)"><g
           id="g2344"
           transform="translate(382.8228,474.6279)"><path
             d="m 0,0 v -106.05 h -0.06 v -71.57 c 0,16.24 -13.16,29.4 -29.4,29.4 -16.014,0 -29.4,-13.384 -29.4,-29.4 v -13.31 h -246.11 c -14.91,0 -26.73,12.741 -26.73,26.73 V 0 c -0.25,15.12 12.25,27.62 27.36,27.37 H -26.73 C -11.78,27.37 0.15,14.8 0,0 Z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2346" /></g><g
           id="g2348"
           transform="translate(261.7407,65.5781)"><path
             d="m 0,0 h 69.092 l 3.66,62.83 c 0.66,12.4 -0.7,24.83 -4.03,36.8 l -2.31,8.34 c -2.78,10 -4.19,20.33 -4.19,30.71 v 79.44 h -246.11 c -14.77,0 -26.73,-11.97 -26.73,-26.74 V 27.37 c 0,-14.91 12.45,-27.3 27.37,-27.37 h 95.339"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2350" /></g><g
           id="g2352"
           transform="translate(101.4712,232.9883)"><path
             d="M 0,0 H 174.925"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2354" /></g><g
           id="g2356"
           transform="translate(212.0591,126.8467)"><path
             d="M 0,0 H 26.696"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2358" /></g><path
           d="m 169.039,113.197 h -67.567 v 74.277 h 67.567 z"
           style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
           id="path2360" /><g
           id="g2362"
           transform="translate(214.2026,460.2129)"><path
             d="m 0,0 -33.974,-10.962 v -16.454 c 0,-21.392 12.402,-40.924 31.875,-49.776 1.322,-0.601 2.099,-0.892 2.099,-0.892 0,0 0.776,0.291 2.098,0.892 19.474,8.852 31.876,28.384 31.876,49.775 v 16.455 z"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2364" /></g><g
           id="g2366"
           transform="translate(101.4712,340.2354)"><path
             d="M 0,0 H 180.723"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2368" /></g><g
           id="g2370"
           transform="translate(327.6064,9.998)"><path
             d="m 0,0 6.883,118.408 c 0.66,12.405 -0.698,24.836 -4.023,36.807 l -2.315,8.337 c -2.777,9.999 -4.185,20.329 -4.185,30.707 v 92.751 c 0,16.014 13.385,29.4 29.4,29.4 16.24,0 29.4,-13.16 29.4,-29.4 v 71.57 H 74.8 c 14.34,0 19.62,-7.35 24.1,-13.46 l 25.9,-51.61 c 10.93,-21.27 11.31,-46.44 1.01,-68.03 L 91.21,159.64 C 83.85,149 82.377,137.818 83.76,123.14 L 96,0"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2372" /></g><g
           id="g2374"
           transform="translate(276.396,169.9277)"><path
             d="M 0,0 H -64.425"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2376" /></g><g
           id="g2378"
           transform="translate(382.7666,297.0078)"><path
             d="M 0,0 V -41.01"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2380" /></g><g
           id="g2382"
           transform="translate(217.9712,65.5781)"><path
             d="M 0,0 V 0"
             style="stroke:#000000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-dasharray:none;stroke-opacity:1"
             id="path2384" /></g></g></g></g></svg>
</template>
